<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.0862 13.0004C20.9635 15.2316 20.0229 17.3467 18.4346 18.9351C16.728 20.6416 14.4134 21.6004 11.9999 21.6004C9.58643 21.6004 7.27181 20.6416 5.56523 18.9351C3.85865 17.2285 2.8999 14.9139 2.8999 12.5004C2.8999 10.0869 3.85865 7.7723 5.56523 6.06572C7.15359 4.47736 9.26865 3.53682 11.4999 3.41412V12.5004V13.0004H11.9999H21.0862Z"
      fill="#A1A1AA"
      stroke="#A1A1AA"
    />
    <path
      d="M14.3999 3.20215C16.0603 3.6323 17.5754 4.49869 18.7882 5.71149C20.001 6.9243 20.8673 8.4394 21.2975 10.0997H14.3999V3.20215Z"
      fill="#A1A1AA"
    />
  </svg>
</template>
